import { CanMatchFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CoreStore } from '@core/store/core.store';
import { userRetrieved$ } from '@core/store/core-store.utils';

/**
 * The error page is reachable only with a cause: an `errorCode` in the store (denied/revoked).
 * The 404 entry is the `**` wildcard route, which renders the page directly and has no guard.
 */
export const errorPageGuard: CanMatchFn = (): Observable<boolean | UrlTree> => {
  const coreStore = inject(CoreStore);
  const router = inject(Router);

  return userRetrieved$().pipe(
    map(() => !!coreStore.errorCode()
      ? true
      : coreStore.isLogged() ? router.createUrlTree(['']) : router.createUrlTree(['login']))
  );
};